import {
  Box,
  Button,
  Flex,
  HStack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import DashboardHeader from "../../../components/common/DashboardHeader";
import { IGetEnrolment } from "../../../models/course-enrolment.model";
import { getLocalUserProfile } from "../../../services/auth.service";
import courseEnrolmentService from "../../../services/course-enrolment.service";
import coursesService from "../../../services/courses.service";
import getService from "../../../services/getService";
import Loading from "../../../components/common/Loading";
// import html2pdf from 'html2pdf.js';

export interface IAvailalableResults {
  trainee_uuid: string;
  enrollment_uuid: string;
  course_name: string;
  enrollment_code: string;
  enrollment_id: number;
  course_duration: number;
  duration_unit: string;
}

const CheckResult = () => {
  const [results, setResults] = useState<IAvailalableResults[]>([]);
  const [enrolmentIds, setEnrolmentIds] = useState<any>([]);
  const [userUuid, setUserUuid] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const toast = useToast();

  useEffect(() => {
    const fetchEnrolledCourses = async () => {
      try {
        const user: any = getLocalUserProfile();
        setUserUuid(user?.uuid);

        if (user) {
          const available_results =
            await courseEnrolmentService.getAvailableResults(user?.uuid);
          setResults(available_results?.available_result);
        }
      } catch (error) {
        console.error("Error fetching enrolled courses and results:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEnrolledCourses();
  }, []);

  const downloadResult = (traineeId: string, enrolmentId: string) => {
    getService
      .get(
        `http://20.126.75.78/naptin/api/v1/users/${traineeId}/courses-enrolled/${enrolmentId}/result-download`,
        {
          method: "GET",
          responseType: "blob", // important
        }
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Trainee-result-${enrolmentId}.pdf`);
        document.body.appendChild(link);
        link.click();

        // Clean up the URL and link
        URL.revokeObjectURL(url);
        document.body.removeChild(link);
        toast({
          title: "Result Download",
          description: "Result downloaded successfully",
          status: "success",
          duration: 2000,
        });
      })

      .catch((err: any) => {
        // console.log(err, "Daaaaaa");
        toast({
          title: "Result Download",
          description: `${
            err.response.data.message ||
            "Complete your enrollment payment to have access to result download"
          }`,
          status: "error",
          duration: 2000,
        });
      });
  };

  const downloadTranscript = (traineeId: string, enrolmentId: string) => {
    getService
      .get(
        `http://20.126.75.78/naptin/api/v1/users/${traineeId}/courses-enrolled/${enrolmentId}/transcript-download`,
        {
          method: "GET",
          responseType: "blob", // important
        }
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Trainee-transcript-${enrolmentId}.pdf`);
        document.body.appendChild(link);
        link.click();
        // Clean up the URL and link
        URL.revokeObjectURL(url);
        document.body.removeChild(link);
        toast({
          title: "Transcript Download",
          description: "Transcript downloaded successfully",
          status: "success",
          duration: 2000,
        });
      })
      .catch((err: any) => {
        // console.log(err, "Daaaaaa");
        toast({
          title: "Transcript Download",
          description: `${
            err.response.data.message ||
            "Complete your enrollment payment to have access to transcript download"
          }`,
          status: "error",
          duration: 2000,
        });
      });
  };

  const downloadPDF = (pdfData: any, fileName = "NAPTIN Result.pdf") => {
    const blobData = new Blob([pdfData], { type: "application/pdf" });

    const objectURL = URL.createObjectURL(blobData);

    const downloadLink = document.createElement("a");
    downloadLink.href = objectURL;
    downloadLink.download = fileName;

    // Trigger the download
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <DashboardHeader />
          <Flex
            justifyContent="center"
            alignItems={"center"}
            bg="#F9F8F8"
            height="95vh"
          >
            <Box
              bgColor={"white"}
              width={"82%"}
              minHeight={"42rem"}
              height={"auto"}
              borderRadius={"4px"}
              boxShadow={"base"}
              padding={"38px 58px"}
            >
              <Text
                fontFamily="Manrope"
                fontSize="28px"
                fontWeight={"600"}
                lineHeight={"130%"}
              >
                My Result(s)
              </Text>
              <Box
                bgColor={"white"}
                width={"100%"}
                minHeight={"10rem"}
                height={"auto"}
                borderRadius={"6px solid #353535"}
                padding={"0.5rem"}
                marginTop={"1rem"}
              >
                {results.length === 0 && results ? (
                  <Flex
                    justifyContent="center"
                    alignItems="center"
                    height="100%"
                    minHeight={"20rem"}
                    flexDirection="column"
                  >
                    <Text fontSize="2xl" fontWeight="bold">
                      No results available
                    </Text>
                    <Text color="gray.500">
                      You have not enrolled in any courses or no results are
                      available yet.
                    </Text>
                  </Flex>
                ) : (
                  <TableContainer
                    height={"30rem"}
                    overflowY={"scroll"}
                    className="scroll-hidden"
                  >
                    <Table variant="simple" style={{ tableLayout: "fixed" }}>
                      <Thead>
                        <Tr>
                          <Th width={"150px"}>Course/Program Name</Th>
                          <Th width={"250px"}>Course/Program Code</Th>
                          <Th width={"100px"}>Duration</Th>
                          <Th width={"200px"}>Download Result</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {results?.map(
                          (each: IAvailalableResults, index: number) => {
                            return (
                              <Tr key={index}>
                                <Td isTruncated width={"150px"}>
                                  {each?.course_name}
                                </Td>
                                <Td isTruncated width={"250px"}>
                                  {each?.enrollment_code}
                                </Td>
                                <Td width={"50px"}>
                                  {each?.course_duration +
                                    " " +
                                    each?.duration_unit}{" "}
                                </Td>
                                <Td width={"150px"}>
                                  <HStack>
                                    <Button
                                      colorScheme="red"
                                      fontSize={"12px"}
                                      onClick={() =>
                                        downloadResult(
                                          userUuid,
                                          each?.enrollment_uuid
                                        )
                                      }
                                    >
                                      Download result
                                    </Button>
                                    <Button
                                      colorScheme="red"
                                      fontSize={"12px"}
                                      variant={"outline"}
                                      onClick={() =>
                                        downloadTranscript(
                                          userUuid,
                                          each?.enrollment_uuid
                                        )
                                      }
                                    >
                                      Download transcript
                                    </Button>
                                  </HStack>
                                </Td>
                              </Tr>
                            );
                          }
                        )}
                      </Tbody>
                    </Table>
                  </TableContainer>
                )}
              </Box>
            </Box>
          </Flex>
        </>
      )}
    </>
  );
};

export default CheckResult;
